import { Route, Routes } from "react-router-dom";
import { ShellPages } from "./shellPages";
import I18n from "../../../core/localization/I18n";
import { UserActionsPage } from "../../../pages/change/dashboard/userReports/userActions/UserActions_view";
import { UserStakeholdersPage } from "../../../pages/change/dashboard/userReports/userStakeholders/UserStakeholders_view";
import { ActionsPage } from "../../../pages/insight/dashboard/actions/Actions_page";
import { Dashboard, OverdueActionsContent } from "../../../pages/insight/dashboard/Dashboard_view";
import { ImpactsPage } from "../../../pages/insight/dashboard/impacts/Impacts_page";
import { PageTitle } from "../../../services/local/pageHeader/PageHeader";

export const DashboardRoutes: React.FC<ReactProps> = () => {
  return (
    <Routes>
      <Route path={ShellPages.dashboards.index.path}>
        <Route
          index
          element={
            <>
              <PageTitle title={I18n.t("phrases.myDashboard")} />
              <Dashboard />
            </>
          }
        />
        <Route path={ShellPages.dashboards.impacts.path} element={<ImpactsPage />} />
        <Route path={ShellPages.dashboards.actions.path} element={<ActionsPage />} />
        <Route path={ShellPages.dashboards.userStakeholders.path} element={<UserStakeholdersPage />} />
        <Route path={ShellPages.dashboards.overdueActions.path} element={<OverdueActionsContent />} />
        <Route path={ShellPages.dashboards.upcomingActions.path} element={<UserActionsPage />} />
      </Route>
    </Routes>
  );
};
